import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import COLORS from 'constants/colors';

import { Tab, Text } from '@cuemath/web-comps';
import { capitalizeFirstLetter } from './utils';

const Container = styled.div`
  overflow: hidden;
  max-height: ${({ showSlots }) => (showSlots ? '100vh' : '0px')};
  transition: max-height 1s ease-in-out;
`;

const CustomTab = styled(Tab)`
  justify-content: flex-start;
`;

const Slots = ({
  slots,
  subTitle,
  slotsStyle,
  handleSetState,
  selectedTab,
  type = '',
  showTimeSlots,
  titleVariant,
  textColor,
  height,
  borderRadius,
  showFillingFast,
  padding,
}) => {
  const showSlots = type.includes('date') || showTimeSlots;
  const formattedSlots = slots.map((slot, index) => {
    const isDateType = type.includes('date');
    const shouldShowFillingFast = showFillingFast && isDateType && index <= 2;

    return {
      ...slot,
      label: shouldShowFillingFast ? `⚡ ${slot.label}` : slot.label,
      subLabel: slot.subLabel || '',
      ...(shouldShowFillingFast && {
        breathingText: '⚡ Fast Filling',
        breathingTextColor: COLORS.YELLOW_4,
      }),
    };
  });

  return (
    <Container showSlots={showSlots}>
      {!!subTitle && (
        <>
          <Text variant={titleVariant} color={textColor}>
            {capitalizeFirstLetter(subTitle)}
          </Text>
        </>
      )}
      <CustomTab
        data={formattedSlots}
        {...slotsStyle}
        justifyContent="flex-start"
        mobileJustifyContent="flex-start"
        variant="btnGroup"
        selectedTab={selectedTab || ''}
        onClick={key => handleSetState(type, key)}
        height={height}
        borderRadius={borderRadius}
        padding={padding}
        minWidth="110px"
        flexWrap="wrap"
      />
    </Container>
  );
};

Slots.defaultProps = {
  subTitle: '',
  slotsStyle: {},
  titleVariant: 'body2',
  textColor: '',
  separatorHeight: null,
  height: '',
  borderRadius: '',
  showFillingFast: false,
  minWidth: '',
  padding: '',
};

Slots.propTypes = {
  slots: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  subTitle: PropTypes.string,
  type: PropTypes.string.isRequired,
  slotsStyle: PropTypes.shape({}),
  handleSetState: PropTypes.func.isRequired,
  selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showTimeSlots: PropTypes.bool.isRequired,
  titleVariant: PropTypes.string,
  textColor: PropTypes.string,
  separatorHeight: PropTypes.number,
  height: PropTypes.string,
  minWidth: PropTypes.string,
  borderRadius: PropTypes.string,
  showFillingFast: PropTypes.bool,
  padding: PropTypes.string,
};

export default Slots;
